import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VueHighlightJS from "vue-highlightjs";
import Kata from "./kata/index";
import DocCom from "./views/doc/components/index";

Vue.config.productionTip = false;

Vue.use(Kata);
Vue.use(DocCom);
Vue.use(VueHighlightJS);

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
